import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import styles from "./Suggestion.module.css";
import levenshtein from "fast-levenshtein";

const ShoppingList = () => {
  const location = useLocation();
  const navigate = useNavigate();
const [loading, setLoading] = useState(false);
  const PRODUCT_API = process.env.REACT_APP_HOME_PAGE_API;

  const [items, setItems] = useState(
    (location.state?.extractedItems || []).map((item) => ({
      name: typeof item === "string" ? item : item.name,
      checked: true,
      qty:
        typeof item === "object" &&
        item.qty !== undefined &&
        item.qty !== null
          ? item.qty
          : "",
    }))
  );

  const toggleItem = (index) => {
    const updated = [...items];
    updated[index].checked = !updated[index].checked;
    setItems(updated);
  };

  const updateItem = (index, value) => {
    const updated = [...items];
    updated[index].name = value;
    setItems(updated);
  };

  const updateQty = (index, value) => {
    const updated = [...items];

    if (value === "") {
      updated[index].qty = "";
    } else {
      updated[index].qty = Math.max(1, Number(value));
    }

    setItems(updated);
  };

const buildCart = async () => {
  try {
    setLoading(true);

    const selectedNames = items
      .filter((i) => i.checked)
      .map((i) => ({
        name: i.name.toLowerCase().trim(),
        qty: i.qty || 1,
      }));

    const res = await axios.get(
      `${PRODUCT_API.replace(/\/$/, "")}/frontend/products`
    );

    const allProducts =
      res.data?.products?.data ??
      res.data?.products ??
      res.data?.data?.products ??
      [];

    const matchedProducts = [];

    selectedNames.forEach((item) => {
      let bestProduct = null;
      let bestScore = Infinity;

      const searchWords = item.name.split(" ").filter(Boolean);

      allProducts.forEach((product) => {
        const productWords = product.name
          .toLowerCase()
          .split(" ")
          .filter(Boolean);

        let totalDistance = 0;

        searchWords.forEach((ocrWord) => {
          let minDistance = Infinity;

          productWords.forEach((productWord) => {
            const distance = levenshtein.get(
              ocrWord,
              productWord
            );

            minDistance = Math.min(minDistance, distance);
          });

          totalDistance += minDistance;
        });

        if (totalDistance < bestScore) {
          bestScore = totalDistance;
          bestProduct = product;
        }
      });

      if (bestProduct && bestScore <= 10) {
        matchedProducts.push({
          ...bestProduct,
          qty: item.qty || 1,
        });
      }
    });

    navigate("/image-search-results", {
      state: {
        products: matchedProducts,
      },
    });
  } catch (err) {
    console.log(err);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>🩺 Medicines Found</h2>

      {items.map((item, index) => (
        <div key={index} className={styles.itemRow}>
          <input
            type="checkbox"
            checked={item.checked}
            onChange={() => toggleItem(index)}
          />

          <input
            type="text"
            value={item.name}
            onChange={(e) => updateItem(index, e.target.value)}
            className={styles.input}
          />

          {item.qty !== "" && (
            <div className={styles.qtyBox}>
              <button
                type="button"
                className={styles.qtyBtn}
                onClick={() =>
                  updateQty(index, Math.max(1, Number(item.qty) - 1))
                }
              >
                −
              </button>

              <input
                type="number"
                min="1"
                value={item.qty}
                onChange={(e) => updateQty(index, e.target.value)}
                className={styles.qtyInput}
              />

              <button
                type="button"
                className={styles.qtyBtn}
                onClick={() =>
                  updateQty(index, Number(item.qty) + 1)
                }
              >
                +
              </button>
            </div>
          )}
        </div>
      ))}

 <button
  className={styles.cartBtn}
  onClick={buildCart}
  disabled={loading}
>
  {loading ? (
    <>
      <span className={styles.spinner}></span>
      Finding Medicines...
    </>
  ) : (
    "Let's Build the Cart"
  )}
</button>
    </div>
  );
};

export default ShoppingList;